import React from "react";
import { useHistory } from "react-router-dom";
import _ from "lodash";

import { AdvancedSearchItems } from "../item-cards";
import useIsAdvancedSearchMobile from "../hooks/useIsAdvancedSearchMobile";

/**
 * Muestra las listas disponibles de la búsqueda avanzada.
 *
 * @param {object} props
 * @param {object} props.textos
 * @param {object} props.data
 * @param {boolean} props.showTitle
 * @param {Function} props.onClose
 */
export const AdvancedSearchReadingLists = ({
    textos,
    data,
    showTitle = true,
    onClose,
}) => {
    const history = useHistory();

    const readingLists = data?.readingLists || [];

    const isAdvancedSearchMobile = useIsAdvancedSearchMobile();

    const getListName = (list) =>
        _.get(textos, list?.name?.translationPath) ||
        list?.name?.defaultValue;

    const handleClick = (list) => {
        history.push({
            pathname: list?.pathname || "/",
            search: list?.search || "",
            state: {
                forceSearchByParams: true,
            },
        });

        onClose && onClose();
    };

    return (
        <section className="advanced-search-reading-lists pt-4 pb-5">

            {showTitle && (
                <h2 className="section-title">
                    {textos?.content?.titulo2 || "Listas"}
                </h2>
            )}

            <div className="d-sm-flex flex-wrap mt-2">
                {readingLists.map((list) => (
                    <div key={list.id || list.pathname} className={`d-flex flex-column ${isAdvancedSearchMobile ? "col-md-6 col-lg-3": "col-md-12 px-2"}`}>
                        <AdvancedSearchItems.ReadingLists
                            name={getListName(list)}
                            icon={list.icon || "tabler:article"}
                            iconClass={list.classIcon || "icon-article"}
                            onClick={() => handleClick(list)}
                        />
                    </div>
                ))}
            </div>

        </section>
    );
};